import { standerdDateForDataCreation } from "../utils/dataFilter";
import http, { host } from "./httpService";

export const GetETATractor_Aryabhatta = async (date) => {
  const response =  await http.get(host + "GetETATractor_Aryabhatta", { params: { Fromdate: date.fromdate, ToDate:date.todate } });
  return response.data.map((item)=>{
    return {
      ...item,
      Date : standerdDateForDataCreation(item.Date)
    }
  })
};

export const InsertBulkDataIntoETATractor_Aryabhatta = async (data) => {
  return await http.post(host + "InsertBulkDataIntoETATractor_Aryabhatta", { _jsonBulkDataIntoETATractor: data,});
};

export const DeleteTractorETAData = async (data) => {
  return await http.delete(host + "DeleteTractorETAData", {data})
}

